import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { TERMS_HTML, TERMS_VERSION, TERMS_EFFECTIVE_DATE } from "../lib/terms";
import { sanitizeHtml } from "../lib/sanitize";

export default function TermsModal({ open, onClose, onAccept }) {
  if (!open) return null;
  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-start justify-center bg-black/50 backdrop-blur-sm p-4 sm:p-6 overflow-y-auto"
      onClick={onClose}
      data-testid="terms-modal"
    >
      <div
        className="bg-[#F4F4F0] border border-[#111] cal-shadow w-full max-w-3xl mt-12 mb-10"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-[#111] px-6 py-4 sticky top-0 bg-[#F4F4F0] z-10">
          <div>
            <div className="font-mono-cal text-[10px] uppercase tracking-widest text-[#666]">[LEGAL]</div>
            <div className="font-display font-bold text-2xl">Terms &amp; Conditions</div>
            <div className="font-mono-cal text-[10px] text-[#666] mt-1">v{TERMS_VERSION} · {TERMS_EFFECTIVE_DATE}</div>
          </div>
          <button onClick={onClose} className="cal-btn cal-btn-ghost" data-testid="terms-modal-close" type="button">
            <X size={14}/> Close
          </button>
        </div>
        <article
          className="cal-prose px-6 py-6 text-sm"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(TERMS_HTML) }}
        />
        {onAccept && (
          <div className="border-t border-[#111] px-6 py-4 flex justify-end gap-3 sticky bottom-0 bg-[#F4F4F0]">
            <button onClick={onClose} className="cal-btn cal-btn-ghost" type="button" data-testid="terms-modal-cancel">Cancel</button>
            <button onClick={() => { onAccept(); onClose(); }} className="cal-btn" type="button" data-testid="terms-modal-accept">
              I accept
            </button>
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
}
